import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { extract } from '@app/core';
import { SettingsComponent } from '@app/settings/settings.component';
import { Shell } from '@app/shell/shell.service';
import { VaccineComponent } from './vaccine/vaccine.component';

const routes: Routes = [
  Shell.childRoutes([
    { path: 'about-dev', component: SettingsComponent, data: { title: extract('About') } },
    { path: 'vaccination', component: VaccineComponent, data: { title: extract('Vaccination') } }
  ])
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class SettingsRoutingModule {}
